export default __webpack_public_path__ + "90f7aa3fa106c799f29d0f103dffabe0.png";